/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-11-01 12:00:34
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-12 15:15:43
 */

import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  PlusCircleOutlined,
  DeleteOutlined,
  CloseOutlined,
} from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Popover,
  Radio,
  Row,
  Select,
  Spin,
} from 'antd'
import _ from 'lodash'
import React, { ReactElement, useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { getChangePayTimeAndMethod } from '../../treatmentLogManagement/treament'
import { getAllPaymentResult } from './paymentResultSlice'
import { PayMethod } from '../../../models/payment'

interface ChargeSettingModalProps {
  visible: boolean
  paymentId: string
  paymentDetailRecords?: any
  modifyLogPage?: any
  modifyLogLoading?: boolean
  paymentMethodList?: any
  onCancel: () => void
  onOk: () => void
  refresh: () => void
}

export const EditPaymentMethodModal = ({
  visible,
  paymentId,
  paymentDetailRecords,
  modifyLogPage,
  modifyLogLoading,
  paymentMethodList,
  onCancel,
  onOk,
  refresh,
}: ChargeSettingModalProps): ReactElement => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  // 修改收费方式相关状态
  const [modifyRecords, setModifyRecords] = useState<any[]>([])
  const [modifyLoading, setModifyLoading] = useState(false)

  // 修改收费方式相关状态
  const handleModifyPayment = async () => {
    const hasChange = modifyRecords.some(
      (record) => record.newPayMethod && record.newPayMethod !== record.payMethod
    )
    if (!hasChange) {
      // 如果没有修改记录 直接关闭弹窗和状态
      onCancel()
      return
    }

    setModifyLoading(true)
    try {
      // 构建需要修改的数据
      const changeList = modifyRecords
        .filter((record) => record.newPayMethod && record.newPayMethod !== record.payMethod)
        .map((record) => ({
          paymentHistoryId: record.id,
          realPayAmount: record.realPayAmount,
          payMethodName: paymentMethodList?.find((d: any) => d.id === record.newPayMethod)?.methodName,
          payMethodId: record.newPayMethod,
        }))
      await dispatch(getChangePayTimeAndMethod({
        paymentId,
        updateMethodFlag: true,
        changePaymentHistoryDTO: changeList,
      }))
        .then(unwrapResult)
        .then(() => {
          notification.success({ message: '修改成功' })
          setModifyRecords([])
          refresh()
        })
    } catch (error) {
      notification.error({ message: '修改失败' })
    } finally {
      onCancel()
      setModifyLoading(false)
    }
  }

  // 修改收费方式 - 处理单条记录修改
   const handleModifyRecord = (record: any, val: any) => {
    const newRecords = [...modifyRecords]
    const index = newRecords.findIndex((r) => r.id === record.id)
    if (index !== -1) {
      newRecords[index] = { ...newRecords[index], newPayMethod: val }
    } else {
      newRecords.push({ ...record, newPayMethod: val })
    }
    setModifyRecords(newRecords)
  }


  return (
    <Modal
      title={<span style={{ fontWeight: 'bold' }}>修改收费方式</span>}
      visible={visible}
      onCancel={() => {
        onCancel();
      }}
      footer={[
        <Button
          key="cancel"
          onClick={() => {
            onCancel();
            setModifyRecords([]);
          }}
        >
          取消
        </Button>,
        <Button
          key="ok"
          type="primary"
          loading={modifyLoading}
          onClick={handleModifyPayment}
        >
          确定
        </Button>,
      ]}
      width={650}
      bodyStyle={{ maxHeight: "420px", overflow: "auto" }}
    >
      <Form
        layout="horizontal"
      >
        {/* 表头 */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          padding: '8px 0',
          marginBottom: 8
        }}>
          <div style={{ width: 220, marginLeft: 60 }}>收费方式</div>
          <div style={{ width: 180, marginLeft: -40 }}>收费金额</div>
          <div style={{ width: 260, marginLeft: -35 }}>收费时间</div>
        </div>

        {/* 表单行 */}
        {paymentDetailRecords?.map((record: any, index: number) => {
          const isDisabled = record.payMethod == PayMethod.Juhe || record.payMethod == PayMethod.YB
          const currentModifyRecord = modifyRecords.find(r => r.id === record.id)
          const currentValue = currentModifyRecord?.newPayMethod || record.payMethod
          const allPaymentMethodList = [...paymentMethodList, { methodName: '医保', id: 99 }]
          const paymethodList = isDisabled ? allPaymentMethodList : paymentMethodList
          const currentMethodName = paymethodList?.find((d: any) => d.id == currentValue)?.methodName
          const value = currentMethodName ? currentValue : record?.payMethodName
          const options = paymethodList?.filter((d: any) => {
            if (d?.id === PayMethod.YB) {
              return (currentModifyRecord?.newPayMethod || record.payMethod) === PayMethod.YB
            }
            if (d?.id === PayMethod.Juhe) {
              return (currentModifyRecord?.newPayMethod || record.payMethod) === PayMethod.Juhe
            }
            return true
          })
          return (
            <Form.Item
              key={record.id}
              style={{ marginBottom: 8 }}
            >
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ width: 150 }}>
                  <Select
                    value={value}
                    style={{ width: '100%' }}
                    disabled={isDisabled}
                    onChange={(val: any) => {
                      handleModifyRecord(record, val)
                    }}
                  >
                    {options?.map((d: any) => (
                      <Select.Option key={d?.id} value={d?.id}>
                        {d?.methodName}
                      </Select.Option>
                    ))}
                  </Select>
                </div>
                <div style={{ width: 120, marginLeft: 16 }}>
                  <div style={{ backgroundColor: '#f5f5f5', padding: '4px 8px', borderRadius: 2, textAlign: 'center' }}>
                    {record.realPayAmount}
                  </div>
                </div>
                <div style={{ width: 180, marginLeft: 16 }}>
                  <div style={{ backgroundColor: '#f5f5f5', padding: '4px 8px', borderRadius: 2 }}>
                    {record.createTime}
                  </div>
                </div>
              </div>
            </Form.Item>
          )
        })}
      </Form>
      <div style={{ marginTop: 60, maxHeight: 100, overflow: 'auto' }}>
        <div style={{ fontWeight: 'bold', marginBottom: 12 }}>
          历史修改记录
        </div>
        {modifyLogLoading ? (
          <div style={{ textAlign: 'center', padding: 20 }}>
            <Spin />
          </div>
        ) : modifyLogPage?.items && modifyLogPage.items.length > 0 ? (
          <div>
            {modifyLogPage.items.map((item: any, index: number) => (
              <div key={index} style={{ padding: '3px 0' }}>
                {item?.beforeValue?.replace(/：/g, '¥') || ''} 改为 {item?.afterValue?.replace(/：/g, '¥') || ''} （{item?.operateName || ''} {item?.operateTime || ''}）
              </div>
            ))}
          </div>
        ) : (
          <div style={{ textAlign: 'center', padding: 20, color: '#999' }}>
            暂无历史修改记录
          </div>
        )}
      </div>
    </Modal>
  )
}
